// @file Helper for drag and drop posts

import { isPostPropertyDefined } from '@@/bits/post_properties'
import type { Post, WallCustomPostSingleSelectProperty } from '@@/types'

const isSingleSelectPropertyRequiredAndPostMovingToNoValueGroup = (
  singleSelect: WallCustomPostSingleSelectProperty | null,
  sourcePost: Post,
  targetPost: Post,
): boolean => {
  if (singleSelect == null || singleSelect.id == null || !singleSelect.required) return false
  return isPostPropertyDefined(sourcePost, singleSelect.id) && !isPostPropertyDefined(targetPost, singleSelect.id)
}

export { isSingleSelectPropertyRequiredAndPostMovingToNoValueGroup }
